import { logout } from "./logout";
import dayjs from "dayjs";
import minMax from "dayjs/plugin/minMax";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import { getProductDashboardData } from "../api/products";
import { getProductOrderPrediction } from "../api/mediaplan";
import { get100DaysROR } from "../api/report";

dayjs.extend(minMax);
dayjs.extend(isSameOrAfter);

export async function predictStockForVariations(
  endDate,
  selectedClients,
  selectedVariations
) {
  const today = dayjs();
  const startDate = today.subtract(5, "day");
  const end = dayjs(endDate);

  const [dashboardRes, predictionRes, rorRes] = await Promise.all([
    getProductDashboardData(
      selectedClients,
      startDate.format("YYYY-MM-DD"),
      end.format("YYYY-MM-DD")
    ),
    getProductOrderPrediction(selectedClients),
    get100DaysROR(selectedClients),
  ]);

  const dashboard = dashboardRes.data;
  const prediction = predictionRes.data;
  const ror = rorRes.data;
  const groupedByVariation = {};
  prediction.forEach((item) => {
    const pv = item.product_variaation_id;
    if (!selectedVariations.includes(pv)) return;
    if (!groupedByVariation[pv]) groupedByVariation[pv] = [];
    groupedByVariation[pv].push(item);
  });

  const results = {};

  for (const variation of selectedVariations) {
    const campaigns = groupedByVariation[variation] || [];

    let totalQtyNeeded = 0;

    let current = today;
    while (current.isSameOrBefore(end, "day")) {
      for (const item of campaigns) {
        const mailDate = dayjs(item.mail_date);
        const dayDiff = current.diff(mailDate, "day");

        if (dayDiff >= 0 && dayDiff <= 100) {
          const rorValue = ror[dayDiff] || 0;
          const qty =
            (((item.target_mail_qty || 0) * (item.estimated_ror || 0)) / 100) *
            (rorValue / 100);
          totalQtyNeeded += qty * item.qty_per_order;
        }
      }
      current = current.add(1, "day");
    }

    totalQtyNeeded = Math.ceil(totalQtyNeeded);

    const product = dashboard.find((p) => p.productVariationId === variation);
    const stockToday = product?.stockQty || 0;

    const qtyNeededUntilStart = await calculateQtyNeededUntilDate(
      today,
      startDate,
      campaigns,
      ror
    );
    const stockOnStartDate = stockToday - qtyNeededUntilStart;

    const qtyOnDelivery = product?.qtyOnDeliveryWithinRange || 0;
    const predictedStock = stockOnStartDate + qtyOnDelivery;
    const predictedMinusNeeded = predictedStock - totalQtyNeeded;

    results[variation] = predictedMinusNeeded;
  }

  return results;
}

async function calculateQtyNeededUntilDate(from, to, campaigns, ror) {
  let qtyNeeded = 0;
  let current = from;

  while (current.isBefore(to, "day")) {
    for (const item of campaigns) {
      const mailDate = dayjs(item.mail_date);
      const dayDiff = current.diff(mailDate, "day");

      if (dayDiff >= 0 && dayDiff <= 100) {
        const rorValue = ror[dayDiff] || 0;
        const qty =
          (((item.target_mail_qty || 0) * (item.estimated_ror || 0)) / 100) *
          (rorValue / 100);
        qtyNeeded += qty * item.qty_per_order;
      }
    }
    current = current.add(1, "day");
  }

  return Math.ceil(qtyNeeded);
}

export function unauthorizedInterceptors(axiosInstance) {
  axiosInstance.interceptors.request.use(
    function (config) {
      const token = localStorage.getItem("accessToken");
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    function (error) {
      return Promise.reject(error);
    }
  );

  axiosInstance.interceptors.response.use(
    function (response) {
      return response;
    },
    function (error) {
      if (error.response && error.response.status === 401) {
        logout();
      } else if (error.response && error.response.status === 500) {
        // window.location.href = "/error-500";
      } else if (error.code == "ERR_NETWORK") {
        // window.location.href = "/error-500";
      }
      return Promise.reject(error);
    }
  );
}
